import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AddressService } from "../../services/address.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { CepModel } from "../../../shared/service/cep/model/cep.model";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-address-completed",
  templateUrl: "./address-completed.page.html",
  styleUrls: ["./address-completed.page.scss"],
})
export class AddressCompletedPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  public name = "";
  public idComponentName = "address-completed";
  idComponentNumber = "address-number";
  placeholder = "Rua";
  error = false;
  errorNumber = false;
  buttonEnable = false;
  textError = "";
  invalidErrorText = "Nome inválido";
  idLabel = "page-address-name";
  label = "Rua";
  headerId = "address-completed";
  titlePage = "Endereço";
  startStage = "";
  endStage = "";
  placeholderNumber = "Número";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idLabelNumber = "page-address-number";
  labelNumber = "Número";
  number = "";
  textErrorNumber = "";
  labelAdjunt = "Complemento";
  idLabelAdjunt = "page-address-adjunt";
  placeholderAdjunt = "Complemento";
  idComponentAdjunt = "address-adjunt";
  textErrorAdjunt = "";
  errorAdjunt = false;
  nameAdjunt = "";
  districAddress = "";
  placeholderDistrict = "Bairro";
  errorDistrict = false;
  idComponentDistrict = "address-district";
  textErrorDistrict = "";
  addressDistrict = "";
  idLabelDistrict = "address-district";
  labelDistrict = "Bairro";
  nameState = "";
  placeholderState = "Estado";
  errorState = false;
  idComponentState = "idComponentState";
  textErrorState = "";
  idLabelState = "";
  labelState = "Estado";
  nameCity = "";
  placeholderCity = "Cidade";
  errorCity = false;
  textErrorCity = "";
  labelCity = "Cidade";
  labelInputCity = "Cidade";
  idComponentCity = "idComponentCity";
  idLabelCity = "";
  invalidErrorTextNumber = "Número inválido";
  addressInitalPostCode: CepModel;
  idLabelAdressCompleted = "idLabelAdressCompleted";
  idButtonAdressCompleted = "idButtonAdressCompleted";
  addressNameForm = this.formBuilder.group({
    nameAddress: this.formBuilder.control("", [
      FormValidations.validationsNameAddress,
    ]),
    numberAddress: this.formBuilder.control("", [
      FormValidations.validationsNumberAddress,
    ]),
    adjuntAddress: this.formBuilder.control("", [
      FormValidations.validationWithRepetition,
    ]),
    districtAddress: this.formBuilder.control("", [
      FormValidations.validationWithRepetition,
    ]),
    stateAddress: this.formBuilder.control("", [
      FormValidations.validationsNameAddress,
    ]),
    cityAddress: this.formBuilder.control("", [
      FormValidations.validationsNameAddress,
    ]),
  });

  addressNumberForm = this.formBuilder.group({});
  constructor(
    private formBuilder: FormBuilder,
    public router: NavController,
    public backNativeService: BackNativeService,
    private addressService: AddressService,
    private title: Title,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest("numero", "number", "address");
    this.editFieldInvest("complemento", "adjunct", "address");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "address";

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressComplete;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathEnderecoCompleto,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  errorMessage() {
    const control = this.addressNameForm.get("nameAddress") as FormControl;
    this.error = control.errors !== null;

    this.buttonEnable = this.error ? false : true;

    if (control.errors?.hasOwnProperty("repeated")) {
      this.textError = this.invalidErrorText;
    }
    if (control.errors?.hasOwnProperty("nameSpace")) {
      this.textError = this.invalidErrorText;
    }
  }

  errorMessageNumber() {
    const control = this.addressNameForm.get("numberAddress") as FormControl;
    this.errorNumber = control.errors !== null;

    this.buttonEnable = this.errorNumber ? false : true;

    if (control.errors?.hasOwnProperty("repeated")) {
      this.textErrorNumber = this.invalidErrorTextNumber;
    }
    if (
      control.errors?.hasOwnProperty("nameSpace") ||
      control.errors?.hasOwnProperty("minlengthNumerAddress")
    ) {
      this.textErrorNumber = this.invalidErrorTextNumber;
    }
  }

  errorMessageAdjunt() {
    const control = this.addressNameForm.get("adjuntAddress") as FormControl;
    this.errorAdjunt = control.errors !== null;

    this.buttonEnable = this.errorAdjunt ? false : true;

    if (control.errors?.hasOwnProperty("repeated")) {
      this.textErrorAdjunt = this.invalidErrorText;
    }
    if (control.errors?.hasOwnProperty("nameSpace")) {
      this.textErrorAdjunt = this.invalidErrorText;
    }
  }

  errorMessageDistrict() {
    const control = this.addressNameForm.get("districtAddress") as FormControl;
    this.errorDistrict = control.errors !== null;

    this.buttonEnable = this.errorDistrict ? false : true;

    if (control.errors?.hasOwnProperty("repeated")) {
      this.textErrorDistrict = this.invalidErrorText;
    }
    if (control.errors?.hasOwnProperty("nameSpace")) {
      this.textErrorDistrict = this.invalidErrorText;
    }
  }

  setValueInput($event: string, input: string) {
    this.addressNameForm.controls[input].setValue($event);
  }

  checkEmptyValue() {
    return (
      this.error ||
      this.errorNumber ||
      this.errorAdjunt ||
      this.errorDistrict ||
      this.addressNameForm.get("nameAddress").value === "" ||
      this.addressNameForm.get("numberAddress").value === "" ||
      this.addressNameForm.get("districtAddress").value === "" ||
      this.addressNameForm.get("stateAddress").value === "" ||
      this.addressNameForm.get("cityAddress").value === ""
    );
  }

  clickNext() {
    this.analyticsEventCliqueContinuar();
    this.addressService.setAddressStreet(this.name);
    this.addressService.setAddressNumber(this.number);
    this.addressService.setAddressAdjunt(this.nameAdjunt);
    this.addressService.setAddressDistrict(this.districAddress);
    this.addressService.setAddressState(this.nameState);
    this.addressService.setAddressCity(this.nameCity);
    this.addressService.setAddressPostalCode(
      this.addressInitalPostCode.postal_code
    );
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.addressComplete,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliqueContinuar() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.continue,
      it_pagename: this.analyticsPage.addressComplete,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliqueInput(label: string) {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: `Preencher${label}`,
      it_pagename: this.analyticsPage.addressComplete,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    this.addressInitalPostCode = this.addressService.addressInitalPostCode;

    this.name =
      `${this.addressInitalPostCode.street_type} ${this.addressInitalPostCode.street}`.trim();
    this.addressNameForm.controls.nameAddress.setValue(
      this.addressInitalPostCode.street
    );

    this.districAddress = this.addressInitalPostCode.district.trim();
    this.addressNameForm.controls.districtAddress.setValue(
      this.addressInitalPostCode.district
    );

    this.nameCity = this.addressInitalPostCode.city;
    this.addressNameForm.controls.cityAddress.setValue(
      this.addressInitalPostCode.city
    );

    this.nameState = this.addressInitalPostCode.state;
    this.addressNameForm.controls.stateAddress.setValue(
      this.addressInitalPostCode.state
    );

    if (this.journeyService.registratioJourney.data.address.number) {
      this.number =
        this.journeyService.registratioJourney.data.address.number.trim();
      this.addressNameForm.controls.numberAddress.setValue(
        this.journeyService.registratioJourney.data.address.number
      );
    }
    if (this.journeyService.registratioJourney.data.address.adjunct) {
      this.nameAdjunt =
        this.journeyService.registratioJourney.data.address.adjunct.trim();
      this.addressNameForm.controls.adjuntAddress.setValue(
        this.journeyService.registratioJourney.data.address.adjunct
      );
    }

    this.errorMessage();
    this.errorMessageNumber();
    this.errorMessageAdjunt();
    this.errorMessageDistrict();
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
